import { render, staticRenderFns } from "./AccessionEntry.vue?vue&type=template&id=4ace19c0&scoped=true&"
import script from "./AccessionEntry.vue?vue&type=script&lang=js&"
export * from "./AccessionEntry.vue?vue&type=script&lang=js&"
import style0 from "./AccessionEntry.vue?vue&type=style&index=0&id=4ace19c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace19c0",
  null
  
)

export default component.exports